import React, { Component } from "react";
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { ComponentHeader, InformationModal } from "../common";
import { API_LIMIT, Notifications, START_PAGE, isModuleExist } from "../../utils/Constant";
import { deleteTemplateApi, getAllTemplateApi } from "./Api";
import TemplateForm from "./TemplateForm";
import { withRouter } from "../../utils/hoc/withRouter";


export class TemplateTab extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(Notifications, 'Template');
    this.state = {
      access: AccesData,
      dummyData: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      languageList: [],
      totalPages: null,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,

      isVerify: false,
      show: false,

      verified: '',
      verifyUrl: ''
    };
  }

  // todo---------------------------------------
  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllTemplateApi(this);
  }
  // todo---------------------------------------
  // todo:-----------------------------------------
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSize = prevParams.get("pageSize") || "";

    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";
    const size = params.get("pageSize") || "";
    // const search = params.get("search") || "";

    if (prevPage !== page || prevVerified !== verified) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllTemplateApi(this);

      });
    }
  }
  // todo:-----------------------------------------

  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state?.showEdit,
      editData: rowData,
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = (id) => {

    deleteTemplateApi(id, this, this.openCloseDeleteModal)
  }
  render() {
    const { showEdit, access } = this.state;
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;

    return (
      <section className="request-section">

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.title} ?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}

        {
          //   true &&
          showEdit &&
          <TemplateForm
            show={showEdit}
            onHide={this.showEditModal}
            editData={this.state.editData}
            this={this}
          />
        }
        <ComponentHeader
          title="Template"
          isSearch={false}
          placeholder={"Search Template"}
          onChangeMethod={this.onChangeMethod}
          clearSearch={() => this.clearSearch()}
          // primaryBtn={access.createAccess?"Add Template":""}
          primaryBtn={""}
          handlePrimaryBtn={() => {

            this.setState({ showEdit: true })
          }}
        />

        <div className="commom-table-wrapper">

          <CustomTable
            data={listData.list || []}
            columns={[

              {
                width: 200,
                title: "Title",
                dataIndex: "title",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                  if (dataKey === "title") {
                    return rowData?.title || "Na";
                  }
                },
              },

              {
                width: 200,
                title: "Template",
                dataIndex: "template",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                  if (dataKey === "template") {
                    return rowData?.template || "Na";
                  }
                },
              },
              {
                width: 120,
                title: "Type",
                dataIndex: "type",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                  if (dataKey === "type") {
                    return rowData?.type?.toUpperCase() || "Na";
                  }
                },
              },
              {
                width: 150,
                title: "Updated By",
                dataIndex: "updatedBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                  if (dataKey === "updatedBy") {
                    return rowData.updatedBy?.name || 'Na';
                  }
                },
              },

              {
                width: 150,
                title: "Created By",
                dataIndex: "createdBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                  if (dataKey === "createdBy") {
                    return rowData.createdBy?.name || 'Na';
                  }
                },
              },


            ]}
            message="No data found" // For Pagination
            history={this.props.history}
            location={this.props.location}
            total={totalPages}
            currentPage={currentPage}
              loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  masterCategoryState: state.MasterCategoryState,
});
const mapDispatchToProps = {
  getAllTemplateApi
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TemplateTab));
